import { Provider } from 'react-redux';
import configureStore from './utils/configureStore';
import Preview from './containers/Preview';
import LiveSurvey from './containers/LiveSurvey';
import { SubmissionUpdatesProvider } from './hooks/useSubmissionUpdates';
import { getInitialQueryParams } from './utils/getInitialQueryParams';
import { SurveyConfigProvider } from './hooks/useSurveyConfig';
import { getLocation } from './utils/windowUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const prepareApp = () => {
  const store = configureStore({});
  const params = getInitialQueryParams(getLocation().search.replace(/^\?/, ''));
  const surveyPath = getLocation().pathname.split('/')[1];
  const surveyType = surveyPath.toUpperCase();
  return {
    props: {
      store,
      params,
      surveyType
    }
  };
};
export function AppComponent({
  store,
  params,
  surveyType
}) {
  const SubmissionComponent = params.isPreview ? Preview : LiveSurvey;
  return /*#__PURE__*/_jsx(Provider, {
    store: store,
    children: /*#__PURE__*/_jsx(SurveyConfigProvider, {
      children: /*#__PURE__*/_jsx(SubmissionUpdatesProvider, {
        children: /*#__PURE__*/_jsx(SubmissionComponent, {
          params: params,
          surveyType: surveyType
        })
      })
    })
  });
}